import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  all: [],
  columns: [
    {
      label: 'Employee Name', field: 'empl_name'
    },
    {
      label: 'Username', field: 'username'
    },
    {
      label: 'Email', field: 'email'
    },
    {
      label: 'Role', field: 'role_name'
    },
    {
      label: 'IP Login', field: 'last_ip_address'
    },
    {
      label: 'Last Access', field: 'last_ip_address_access'
    },
    {
      label: 'Action', field: 'action'
    }
  ],
  pages: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'master/admins/status/AC'}
    useIPA.get(param).then(response => {
      const admin = {
        rows : response.data.data,
        pages : [10, 25, 50, 150]
      }
      commit('setData', {...admin})
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/admin/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = {
        employee_id: formData.select_1,
        role_id: formData.select_2,
        type: formData.checkbox_1 === true ? 'A' : 'U',
        username: formData.text_1,
        email: formData.text_2,
        password: formData.text_3,
        phone: formData.text_4,
        pin: formData.text_5
			}
      const param = { rawData: rawData, url: 'dashboard/master/admin', id: formData.id }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'admin-user' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/admin', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, admin) {
    state.all = admin.rows
    state.pages = admin.pages
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
